import type { TFunction } from '!/i18n'
import type { UiCategoryWithVods, VodWithPrice } from '@/interfaces'
import {
  extendMediaItemByLabelPrice,
  getLeftTimeString,
  getProgress,
  getViewedTimeString,
} from '@/tools'
import type { CategoryWithVods, Vod } from '@setplex/tria-api'
import { type AdjustPurchaseableFn } from '~/features/payment/sse-purchases'
import { type FormattedVodWithPrice } from './index.h'

export const formatCategoryWithVodsToUi = (
  data: CategoryWithVods | null,
  adjust: AdjustPurchaseableFn,
  t: TFunction
): UiCategoryWithVods | null => {
  if (!data) return null

  const formattedContent = data.content.map((vod) =>
    extendMediaItemByLabelPrice(adjust(vod))
  ) as VodWithPrice[]

  const name = data.id === 0 ? t('all') : data.name

  return {
    ...data,
    name,
    content: formattedContent,
  }
}

export const formatVod = ({
  item,
  adjust,
  t,
}: {
  item: Vod
  adjust?: AdjustPurchaseableFn
  t: TFunction
}): FormattedVodWithPrice => {
  const mediaByLabelPrice = extendMediaItemByLabelPrice(
    adjust ? adjust(item) : item
  ) as VodWithPrice

  const { duration, stoppedTime } = (item || {}) as Vod

  const progress = getProgress({
    duration,
    stoppedTime,
  })

  const timeLeft = getLeftTimeString({
    duration,
    stoppedTime,
    t,
  })

  const viewedTime = getViewedTimeString(stoppedTime)

  return {
    ...mediaByLabelPrice,
    progress,
    timeLeft,
    viewedTime,
  }
}
